<template>
    <nav class="bg-teal-darker fixed w-full z-50">
        <slot name="eyebrow" />

        <div
            class="container max-w-7xl font-semibold text-white text-lg lg:text-sm py-3 lg:pb-0 lg:pt-1 mx-auto"
        >
            <button
                class="lg:hidden text-white text-xl font-semibold my-3 flex items-center mx-auto leading-none"
                @click="expanded = !expanded"
            >
                <transition name="fade" mode="out-in">
                    <svg
                        v-if="expanded"
                        key="expanded"
                        class="w-6 inline-block mb-px mr-2 text-white"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                    >
                        <path
                            d="m16.24 14.83a1 1 0 0 1 -1.41 1.41l-2.83-2.83-2.83 2.83a1 1 0 0 1 -1.41-1.41l2.83-2.83-2.83-2.83a1 1 0 0 1 1.41-1.41l2.83 2.83 2.83-2.83a1 1 0 0 1 1.41 1.41l-2.83 2.83z"
                        />
                    </svg>

                    <svg
                        v-else
                        key="not-expanded"
                        class="w-6 inline-block mb-px mr-2 text-white"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                    >
                        <path
                            d="m4 5h16a1 1 0 0 1 0 2h-16a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2h-16a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2h-16a1 1 0 0 1 0-2z"
                        />
                    </svg>
                </transition>

                <span class="block">MENU</span>
            </button>

            <div
                :class="{ 'nav-open': expanded }"
                class="nav-container flex flex-col lg:flex-row items-center justify-between"
                @click="expanded = !expanded"
            >
                <slot />
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            expanded: false,
        };
    },
};
</script>

<style scoped>
.nav-container {
    overflow: hidden;
    max-height: 0px;
}

.nav-container.nav-open {
    max-height: 500px;
    transition: max-height 0.3s;
}

@media (min-width: 1024px) {
    .nav-container {
        overflow: initial;
        max-height: 100vh !important;
    }
}
</style>
